import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import {setScreen, showMainMenu} from "../../../store/actions/screens";
import {SlideShow} from "../../common/slideshow/SlideShow";
import {SCREENS} from "../../../store/reducers/screen";
import {startGame} from '../../../store/actions/game';

interface Props extends IScreenComponentProps
{
    showMainMenu: () => void;
    startGame: () => void;
}

import './GameIntro.scss';

class GameIntro extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }



    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {showMainMenu, startGame} = this.props;

        if (! this.props.active) return null;

        return <SlideShow
                    onCancel={showMainMenu}
                    onComplete={startGame}>

            <div styleName={'slide'}>
                <img src="./img/game-intro/1.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/2.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/3.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/3a.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/4.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/5.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/6.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/7.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/8.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/9.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/10.png" />
            </div>

            <div styleName={'slide'}>
                <img src="./img/game-intro/11.png" />
            </div>

        </SlideShow>
    }
}


const mapStateToProps = state =>
{
    return {
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        startGame: () => dispatch(startGame()),
        showMainMenu: () => dispatch(showMainMenu()),
    }
};

export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(GameIntro));



// WEBPACK FOOTER //
// ./src/ts/app/screens/game-intro/GameIntro.tsx